import React from 'react';

import { Box, Breadcrumbs as MaterialBreadcrumbs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

import AnimatedSkeleton from '~/components/AnimatedSkeleton';
import { SMALL_MARGIN_PX } from '~/theme';

export type Crumb = {
  url?: string;
  title: string;
};

interface BreadcrumbsProps {
  crumbs?: Crumb[];
  className?: string;
  loading?: boolean;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  crumbs,
  className = '',
  loading = false,
  ...rest
}) => {
  if (loading) {
    return (
      <LoadingWrapper className={className}>
        <AnimatedSkeleton xs="24px" />
      </LoadingWrapper>
    );
  }

  if (crumbs?.length === 0) return null;

  return (
    <Wrapper className={className} data-testid={rest['data-testid']}>
      <MaterialBreadcrumbs aria-label="breadcrumb">
        {crumbs?.map((item, i) => {
          if (!item.title) {
            return null;
          }
          if (i !== crumbs.length - 1) {
            return (
              <Link data-testid="breadcrumbLink" key={item.url} to={item.url || ''}>
                <StyledCrumb>{item.title}</StyledCrumb>
              </Link>
            );
          } else {
            return (
              <LastCrumb data-testid="breadcrumbCurrent" key={item.title}>
                {item.title}
              </LastCrumb>
            );
          }
        })}
      </MaterialBreadcrumbs>
    </Wrapper>
  );
};

export default Breadcrumbs;

const LoadingWrapper = styled('div')`
  display: flex;
  max-width: 460px;
`;
const Wrapper = styled(Box)`
  position: relative;
  margin-bottom: ${SMALL_MARGIN_PX};
  margin-top: 0;
  & .MuiBreadcrumbs-separator {
    color: ${({ theme }) => theme.palette.common.white};
    font-weight: 700;
  }
`;
const StyledCrumb = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.white};
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2;
`;
const LastCrumb = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.text.secondaryAccent};
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
`;
